"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var appFeaturesSlider = /** @class */ (function () {
    function appFeaturesSlider() {
        this.$owl = $('.app-features__carousel');
        this.initCarousel();
    }
    appFeaturesSlider.prototype.initCarousel = function () {
        this.$owl.owlCarousel({
            items: 1,
            slideSpeed: 2000,
            nav: false,
            autoplay: true,
            dots: true,
            loop: true,
            responsive: {
                768: {
                    items: 2,
                },
                1024: {
                    items: 3,
                    autoplay: false,
                    loop: false,
                }
            }
        });
    };
    return appFeaturesSlider;
}());
exports.default = appFeaturesSlider;
